import { render, staticRenderFns } from "./Login_phone.vue?vue&type=template&id=5b363f47"
import script from "./Login_phone.vue?vue&type=script&lang=js"
export * from "./Login_phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports